import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Phone} from '../../../../../projects/shared-lib/src/lib/models/phone';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MyNumberOnlyDirective } from '../../directive/my-number-only.directive';
import { FormErrorMessageComponent } from '../form/form-error-message/form-error-message.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tw-phone-form',
    templateUrl: './phone-form.component.html',
    styleUrls: ['./phone-form.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MyNumberOnlyDirective, MatError, FormErrorMessageComponent, TranslatePipe]
})
export class PhoneFormComponent implements OnInit, OnChanges {

    @Input() formGroupPhone:any | UntypedFormGroup;
    @Input()  phone: Phone;

    constructor(private fb: UntypedFormBuilder) {

    }

    ngOnInit() {
        const phoneType = (this.phone && this.phone.type) ? this.phone.type.toUpperCase() : 'MAISON';

        this.formGroupPhone.addControl('number', this.fb.control((this.phone && this.phone.number) ? this.phone.number : '', Validators.required));
        this.formGroupPhone.addControl('type', this.fb.control(phoneType));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['phone'] && !changes['phone'].firstChange && this.formGroupPhone) {
            const phoneType = (this.phone && this.phone.type) ? this.phone.type.toUpperCase() : 'MAISON';

            this.formGroupPhone.patchValue({
                number: (this.phone && this.phone.number) ? this.phone.number : '',
                type: phoneType
            });
        }
    }

}
